import CleanUserStateButton from '@/components/resetUserButton/CleanUserStateButton.tsx';
import CONFIG from '@/config/config.ts';
import ProcessStateRenderer from '@/views/process/components/ProcessStateRenderer.tsx';
import React from 'react';

const ProcessView: React.FC = () => {
  return (
    <>
      {CONFIG.ENVIRONMENT === 'local' && <CleanUserStateButton />}
      <ProcessStateRenderer />
    </>
  );
};

export default ProcessView;
